export const environment = {
  production: false,
  type: 'test',
    accept: '10web',
  baseUrl: 'https://10web.io/',
  dashUrl: 'https://testmy.10web.io/',
  demoUrls: ['https://demoaisite.10web.io', 'https://demo.10web.club'],
  vibeCodingEndpoint: 'https://test-ac-api-gateway.10web.io/wvc/api',
    coreEndpoint: 'https://test-ac-api-gateway.10web.io/core/api/',
    authEndpoint: 'https://test-ac-api-gateway.10web.io/auth/',
    publicEndpoint: 'https://test-ac-api-gateway.10web.io/core/public/api/',
    managerEndpoint: 'https://test-ac-api-gateway.10web.io/manager/api/',
    backupEndpoint: 'https://test-ac-api-gateway.10web.io/backup/api/',
    optimizerEndpoint: 'https://test-ac-api-gateway.10web.io/imageoptimizer/',
    seoEndpoint: 'https://test-ac-api-gateway.10web.io/seo/api/',
    performanceEndpoint: 'https://test-ac-api-gateway.10web.io/performance/v1/',
    securityEndpoint: 'https://test-ac-api-gateway.10web.io/security/api/',
    notificationsEndpoint: 'https://test-ac-api-gateway.10web.io/notifications/api/',
    notificationsSocketEndpoint: 'wss://notifications',
    lxdEndpoint: 'https://test-ac-api-gateway.10web.io/lxd/api/',
    typeFormEndpoint: 'https://test-ac-api-gateway.10web.io/api.typeform.com',
    aiAssistantEndpoint: 'https://test-ac-api-gateway.10web.io/ai-assistant/',
    optimizerDemonstrationEndpoint: 'https://test-ac-api-gateway.10web.io/optimizerdemonstration/api',
    aiBuilderEndpoint: 'https://test-ac-api-gateway.10web.io/x/api/',
    woocomEndpoint: 'https://test-ac-api-gateway.10web.io/woocommerce/woocommerce/',
    tenWebWoocomEndpoint: 'https://test-ac-api-gateway.10web.io/woocommerce/tenwebwoocommerce/',
    tenWebStripeEndpoint: 'https://test-ac-api-gateway.10web.io/woocommerce/payments-stripe/',
    woocomPaymentsEndpoint: 'https://test-ac-api-gateway.10web.io/woocommerce/payments/',
    woocomAnalyticsEndpoint: 'https://test-ac-api-gateway.10web.io/woocommerce/woocommerce-analytics/',
    expertsUrl: 'https://test-ac-api-gateway.10web.io/experts/',
    miniProductsEndpoint: 'https://test-ac-api-gateway.10web.io/mini-products/api/',
    miniToolsEndpoint: 'https://test-ac-api-gateway.10web.io/brand-kit/',
  wvcAcceptToken: 'ghUy2ZMrzOrbLWD8gdgdKSox3hpxV51NkZDbh5s6H3tP',
  stripeKey: 'pk_test_51SI7mSDGnITaBeEjftjmfqhKufa3qywJvkgWjyC6nkZ7pXDzS2HVO49zH6m4LucELMTwl5m1znscVN3aRgiBed6W00h0G9JsUH',
  googleRecaptcha: '6LeKu8YqAAAAAOjyZPPHbrgbaKFYqTP0groE1hJk',
  paypalIsProduction: false,

  enableGoogleAnalytics: true,
  enableLuckyOrange: false,

  hostname: '10web.club',

  firebaseConfig: {
    apiKey: "AIzaSyA1TkRrRfHv9TS5N09oFLr0EQM22ixjbwY",
    authDomain: "notifications-test-73ec2.firebaseapp.com",
    databaseURL: "https://notifications-test-73ec2.firebaseio.com",
    projectId: "notifications-test-73ec2",
    storageBucket: "notifications-test-73ec2.appspot.com",
    messagingSenderId: "783439187940"
  },
  firebasePublicConfig: {
    apiKey: "AIzaSyB2Iqwy5KcXMgbTpy-5HfGHVMK-WggBdHA",
    authDomain: "tenweb-hosting-services.firebaseapp.com",
    databaseURL: "https://tenweb-hosting-services.firebaseio.com",
    projectId: "tenweb-hosting-services",
    storageBucket: "tenweb-hosting-services.firebasestorage.app",
    messagingSenderId: "179822974689"
  },
  googleInsightsKey: 'AIzaSyC5kvK80IwtG9PBFfuXRzLZmxIh7MAB_tA',
  defaultStarterPlanId: 321,
  apiResellerPlanId: 476,
  speedStartedPlanId: 323,
  basePlanId: 322,
  boosterBetaPlanId: 324,
  photoGalleryPluginIds: ['204', '101'],
  aiBuilderPluginIds: ['191', '207', '210'],
  aiAssistantPluginId: 205,
  demoAiPluginId: 207,
  demoDomainId: 8993,
  demoWorkspaceId: 7548,
  imageOptimizerPluginId: 69,
  aiCreateWebsitePluginId: 208,
  managerPluginId: 51,
  installBlankPluginId: 209,
  builder2PluginId: 210,
  builder2HostedPluginId: 211,
    vibeCodingPluginId: 216,
  availableSubscriptionId: 374,
    suiteDevRoleId: 6,
  smoochIntegrationId: "659bda10370bbb7ba92da6da",
  hubspotAgencyFormId: "9c5e1b87-e6d6-4da1-afc4-18acd3ce3074",
  hubspotDedicatedFormId: "a6637c78-af7e-4efd-b4ce-5d6288153569",
  hubspotAiBuilderFormId: "12974eb0-ad55-4d40-892f-690c06d80343",
  demoWebsiteUrl: 'https://dummy.10web.club',
  aiStarterAnnual: 375,
};
